import { h, r as registerInstance, c as createEvent, f as forceUpdate, H as Host } from './index-dba4409d.js';
import { i as i18nProvider, l as loadTranslations } from './loadTranslations-46795824.js';
import { g as getSoftwares, a as getSoftwareTypes, S as SOFTWARE_TYPES, b as getSoftwareModulesByType, c as createRequestData } from './createCase-7e2d933f.js';
import { a as getAuthClient, b as authClientName, A as ApiClient, s as setEnv, g as getEnvConfig, c as getPublicApiClient } from './publicApiClient-f3b890c3.js';
import { c as createStore, a as createAuthStore, w as whenAuthenticated, S as SilentAuth } from './auth-55549ef7.js';

/**
 * This can be used like a Fragment in React. https://legacy.reactjs.org/docs/fragments.html
 */
const Fragment = (_props, children) => [...children];

const FormSteps = ({ multipleSteps }, children) => {
    if (!multipleSteps)
        return children;
    return h("ux-form-steps", null, children);
};
const FormStep = ({ multipleSteps }, children) => {
    if (!multipleSteps)
        return children;
    return h("ux-form-step", null, children);
};
const StepNavigation = ({ t, multipleSteps, currentStep }) => multipleSteps ? (h("div", { class: "ux-u-margin-top-40 ux-u-margin-bottom-40", style: { "min-height": "87px" } },
    h("ux-steps", null,
        h("ux-steps-item", { "data-ux-form-steps-prev": currentStep === 2 ? true : undefined, number: 1, current: currentStep === 1, done: currentStep === 2 }, t("headline.caseDetails")),
        h("ux-steps-item", { number: 2, current: currentStep === 2, "data-ux-form-steps-next": currentStep === 1 ? true : undefined }, t("headline.contactData"))))) : null;
const StepNext = ({ t, multipleSteps, onCancel }) => multipleSteps ? (h("div", { class: "ux-row" },
    h("div", { class: "ux-col-12 ux-u-margin-bottom-20" },
        h("div", { class: "ux-text-normal ux-text-normal--light-gray" },
            h("p", null, t("validation.requiredFieldsExplanation")))),
    h("div", { class: "ux-col-12" },
        h("div", { class: "ux-u-d-flex ux-u-flex-jc-between ux-u-flex-dir-row-reverse" },
            h("ux-button", { "data-ux-form-steps-next": true, variant: "primary" }, t("button.next")),
            h("ux-button", { type: "button", onClick: () => onCancel() }, t("button.cancel")))))) : null;
const StepBack = ({ t, multipleSteps }) => multipleSteps ? (h("ux-button", { "data-ux-form-steps-prev": true, type: "button" }, t("button.back"))) : null;

/**
 * Decodes a JWT token to an object
 * implementation from https://stackoverflow.com/questions/38552003/how-to-decode-jwt-token-in-javascript-without-using-a-library
 * @param token JWT token
 * @returns object
 */
function decodeJwt(token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""));
    return JSON.parse(jsonPayload);
}

const getAssets = async (apiClient) => {
    const idToken = getAuthClient(authClientName).getIdToken();
    const decoded = decodeJwt(idToken);
    const { customerNumber } = decoded;
    return apiClient
        .request(`/asset-management/1.0/core/assets/parameters?customerOrgId=${customerNumber}&isCustomOnly=false&isRootAsset=true`, {
        method: "GET",
        mockResponse
    })
        .then((response) => {
        if (response.assets) {
            return response.assets;
        }
        return Promise.reject("No assets found");
    });
};
const mockResponse = {
    assets: [
        {
            assetId: "A0660A0576",
            assetName: "Quicksharp",
            technologyId: "PUNCHING"
        },
        {
            assetId: "LS00093708",
            assetName: "HL 54P",
            technologyId: "PULSEDLASER"
        },
        {
            assetId: "E0551A0120",
            assetName: "HL 101P",
            technologyId: "PULSEDLASER"
        },
        {
            assetId: "LS00009160",
            assetName: "HL 2006D",
            technologyId: "PULSEDLASER"
        },
        {
            assetId: "LS00093844",
            assetName: "HL 2006D",
            technologyId: "PULSEDLASER"
        },
        {
            assetId: "N0053A0020",
            assetName: "SortMaster (AL28)",
            technologyId: "AUTOMATION"
        },
        {
            assetId: "C0200I0005",
            assetName: "Toolshuttle",
            technologyId: "AUTOMATION"
        },
        {
            assetId: "883850",
            assetName: "TRBV85SX",
            technologyId: "BENDING"
        },
        {
            assetId: "B0501A0185",
            assetName: "TruBend 5050",
            technologyId: "BENDING"
        },
        {
            assetId: "B1503I0001",
            assetName: "TruBend 5085 (B23)",
            technologyId: "BENDING"
        },
        {
            assetId: "B1504I0151",
            assetName: "TruBend 5130 (B23)",
            technologyId: "BENDING"
        },
        {
            assetId: "B1505I0280",
            assetName: "TruBend 5170 (B23)",
            technologyId: "BENDING"
        },
        {
            assetId: "B1505I0637",
            assetName: "TruBend 5170 (B23)",
            technologyId: "BENDING"
        },
        {
            assetId: "B1507I0001",
            assetName: "TruBend 5230 (B23)",
            technologyId: "BENDING"
        },
        {
            assetId: "B1509I0001",
            assetName: "TruBend 5320 (B23)",
            technologyId: "BENDING"
        },
        {
            assetId: "B0702A2028",
            assetName: "TruBend 7036",
            technologyId: "BENDING"
        },
        {
            assetId: "B0702A2031",
            assetName: "TruBend 7036",
            technologyId: "BENDING"
        },
        {
            assetId: "B1703I0086",
            assetName: "TruBend 7050 (B28)",
            technologyId: "BENDING"
        },
        {
            assetId: "E0953A0235",
            assetName: "TruDisk 2001 (4C)",
            technologyId: "DISKLASER"
        },
        {
            assetId: "E0953A0078",
            assetName: "TruDisk 4002 (4C)",
            technologyId: "DISKLASER"
        },
        {
            assetId: "E1153A0485",
            assetName: "TruDisk 4002 (4C)",
            technologyId: "DISKLASER"
        },
        {
            assetId: "E1153A0426",
            assetName: "TruDisk 6602 (4 C)",
            technologyId: "DISKLASER"
        },
        {
            assetId: "E0953A0227",
            assetName: "TruDisk 8002 (2C)",
            technologyId: "DISKLASER"
        },
        {
            assetId: "E1053A0162",
            assetName: "TruDisk  3001 (4 C)",
            technologyId: "DISKLASER"
        },
        {
            assetId: "A0221E0833",
            assetName: "TruLaser 3030 fiber (L49)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "A0221E1065",
            assetName: "TruLaser 3030 fiber (L49)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "A2221E0146",
            assetName: "TruLaser 3030 fiber (L95)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "A3231E0025",
            assetName: "TruLaser 5030 fiber (L76)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "A3231E0518",
            assetName: "TruLaser 5030 fiber (L76)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "S2321M0144",
            assetName: "TruLaser Cell 3000 (L34)",
            technologyId: "WELDING"
        },
        {
            assetId: "S0541C0287",
            assetName: "TruLaser Cell 7040 (L31) fiber",
            technologyId: "3DLASERCUTTING"
        },
        {
            assetId: "S0541C0328",
            assetName: "TruLaser Cell 7040 (L31) fiber",
            technologyId: "3DLASERCUTTING"
        },
        {
            assetId: "A0280E0038",
            assetName: "TruLaser Center 7030 (L26)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "A0280E0127",
            assetName: "TruLaser Center 7030 (L26)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "A0455A0024",
            assetName: "TruLaser Robot 5020",
            technologyId: "LASERTUBECUTTING"
        },
        {
            assetId: "A0455A0037",
            assetName: "TruLaser Robot 5020",
            technologyId: "LASERTUBECUTTING"
        },
        {
            assetId: "A1441D0079",
            assetName: "TruLaser Tube 7000 fiber",
            technologyId: "LASERTUBECUTTING"
        },
        {
            assetId: "A0150A0160",
            assetName: "TruMatic 7000",
            technologyId: "COMBINED"
        },
        {
            assetId: "A1150D0126",
            assetName: "TruMatic 7000 (K08) Medium format",
            technologyId: "COMBINED"
        },
        {
            assetId: "A0460A0004",
            assetName: "TrumaWeld L 1000",
            technologyId: "WELDING"
        },
        {
            assetId: "A0420A0232",
            assetName: "TRUMPF Lasercell 1005",
            technologyId: "3DLASERCUTTING"
        },
        {
            assetId: "S0711Q0095",
            assetName: "TruPrint 1000 (G01)",
            technologyId: "3DPRINTING"
        },
        {
            assetId: "E0851A0036",
            assetName: "TruPulse 203",
            technologyId: "PULSEDLASER"
        },
        {
            assetId: "E0851A0048",
            assetName: "TruPulse 556",
            technologyId: "PULSEDLASER"
        },
        {
            assetId: "E0652A0387",
            assetName: "VectorMark Compact 1",
            technologyId: "MARKINGLASER"
        }
    ]
};

const getNotificationTypes = async (apiClient) => {
    return apiClient.request("/servicecall/getnotificationtypes", {
        mockResponse: mockNotificationTypes
    });
};
const NOTIFICATION_TYPES = {
    MACHINE_STOP: 20,
    FAULT_WITHOUT_STOP: 10,
    PROGRAMMING_SOFTWARE: -100,
    CLARIFICATION_SPARE_PARTS: 50,
    OTHER: 40,
    MAINTENANCE_REQUEST: 120,
    SPARE_PARTS_ORDER: 140,
    APPLICATION_ISSUES: 80
};
const mockNotificationTypes = [
    {
        Id: NOTIFICATION_TYPES.MACHINE_STOP,
        LabelKey: "Maschinenstillstand"
    },
    {
        Id: NOTIFICATION_TYPES.FAULT_WITHOUT_STOP,
        LabelKey: "Störung ohne Stillstand"
    },
    {
        Id: NOTIFICATION_TYPES.PROGRAMMING_SOFTWARE,
        LabelKey: "Programmierung / Software"
    },
    {
        Id: NOTIFICATION_TYPES.CLARIFICATION_SPARE_PARTS,
        LabelKey: "Klärung Ersatzteile"
    },
    {
        Id: NOTIFICATION_TYPES.OTHER,
        LabelKey: "Sonstiges"
    },
    {
        Id: NOTIFICATION_TYPES.MAINTENANCE_REQUEST,
        LabelKey: "Wartungsanfrage"
    },
    {
        Id: NOTIFICATION_TYPES.SPARE_PARTS_ORDER,
        LabelKey: "Bestellung Ersatzteile"
    },
    {
        Id: NOTIFICATION_TYPES.APPLICATION_ISSUES,
        LabelKey: "Applikationsthemen"
    }
];

const createApiStore = () => {
    const store = createStore({
        machinesLoading: true,
        machines: [],
        softwaresLoading: true,
        softwares: [],
        softwareTypes: [],
        notificationTypesLoading: true,
        notificationTypes: [],
        loading: true
    });
    store.onChange("machinesLoading", () => updateLoading());
    store.onChange("softwaresLoading", () => updateLoading());
    store.onChange("notificationTypesLoading", () => updateLoading());
    function updateLoading() {
        store.state.loading = store.state.machinesLoading || store.state.softwaresLoading || store.state.notificationTypesLoading;
    }
    return store;
};
const loadFormDataFromPublicApi = async (apiStore, apiClient) => {
    apiStore.state.softwaresLoading = true;
    apiStore.state.notificationTypesLoading = true;
    getSoftwares(apiClient).then((softwares) => {
        apiStore.state.softwares = softwares;
        apiStore.state.softwareTypes = getSoftwareTypes(softwares);
        apiStore.state.softwaresLoading = false;
    });
    getNotificationTypes(apiClient).then((notificationTypes) => {
        apiStore.state.notificationTypes = notificationTypes;
        apiStore.state.notificationTypesLoading = false;
    });
};
const loadFormDataFromAssetManagementApi = async (apiStore, apiClient) => {
    apiStore.state.machinesLoading = true;
    getAssets(apiClient).then((machines) => {
        apiStore.state.machines = machines;
        apiStore.state.machinesLoading = false;
    });
};

const APPLICATION_IDS = {
    WELDING: 1,
    PLASTIC: 2,
    CUTTING: 3,
    HARDENING: 4,
    MARKING: 5,
    OTHER: 6,
    FIXED_OPTICS_BEO: 7,
    PFO20_33: 8,
    PFO3D: 9,
    I_PFO: 10,
    OTHER_OPTICS: 11,
    WELD_DEPTH: 12,
    HARDNESS: 13,
    CRACKING: 14,
    BUBBLE_SPLATTER: 15,
    PROCESS_DATA: 16,
    OTHER_WELDING: 17
};
const applicationsLaser = [
    {
        labelKey: "welding",
        id: APPLICATION_IDS.WELDING
    },
    {
        labelKey: "plastic",
        id: APPLICATION_IDS.PLASTIC
    },
    {
        labelKey: "cutting",
        id: APPLICATION_IDS.CUTTING
    },
    {
        labelKey: "hardening",
        id: APPLICATION_IDS.HARDENING
    },
    {
        labelKey: "marking",
        id: APPLICATION_IDS.MARKING
    },
    {
        labelKey: "other",
        id: APPLICATION_IDS.OTHER
    }
];
const applicationsOptics = [
    {
        labelKey: "fixedOpticsBEO",
        id: APPLICATION_IDS.FIXED_OPTICS_BEO
    },
    {
        labelKey: "PFO20/33",
        id: APPLICATION_IDS.PFO20_33
    },
    {
        labelKey: "PFO3D",
        id: APPLICATION_IDS.PFO3D
    },
    {
        labelKey: "I-PFO",
        id: APPLICATION_IDS.I_PFO
    },
    {
        labelKey: "other",
        id: APPLICATION_IDS.OTHER_OPTICS
    }
];
const applicationsWelding = [
    {
        labelKey: "weldDepth",
        id: APPLICATION_IDS.WELD_DEPTH
    },
    {
        labelKey: "hardness",
        id: APPLICATION_IDS.HARDNESS
    },
    {
        labelKey: "cracking",
        id: APPLICATION_IDS.CRACKING
    },
    {
        labelKey: "bubbleSplatter",
        id: APPLICATION_IDS.BUBBLE_SPLATTER
    },
    {
        labelKey: "processData",
        id: APPLICATION_IDS.PROCESS_DATA
    },
    {
        labelKey: "other",
        id: APPLICATION_IDS.OTHER_WELDING
    }
];

const hideMachinesForNotificationTypes = [NOTIFICATION_TYPES.PROGRAMMING_SOFTWARE];
const showErrorNumbersForNotificationTypes = [
    null,
    NOTIFICATION_TYPES.APPLICATION_ISSUES,
    NOTIFICATION_TYPES.MACHINE_STOP,
    NOTIFICATION_TYPES.FAULT_WITHOUT_STOP
];
const hideErrorNumbersForTechnologies = ["ELECTRONICS"];
const showSoftwareFieldsForNotificationTypes = [NOTIFICATION_TYPES.PROGRAMMING_SOFTWARE];
const showSoftwareModulesForSoftwareTypes = [SOFTWARE_TYPES.TRUTOPS, SOFTWARE_TYPES.TRUTOPS_FAB, SOFTWARE_TYPES.TRUTOPS_BOOST];
const showApplicationIssuesForNotificationTypes = [NOTIFICATION_TYPES.APPLICATION_ISSUES];
const showApplicationIssuesForTechnologies = [
    "PULSEDLASER",
    "SHORTPULSEDLASER",
    "DISKLASER",
    "FIBERLASER",
    "DIODELASER",
    "MARKINGLASER"
];
const showWeldingApplicationFieldsForApplication = [APPLICATION_IDS.WELDING];
const createFormStore = () => {
    const store = createStore({
        selectedNotificationType: null,
        selectedSoftwareType: null,
        selectedApplication: null,
        formIsSubmitted: false,
        selectedMachineTechnology: null,
        showErrorNumbers: true,
        showApplications: false,
        showSoftwareModules: false,
        showMachines: true,
        showSoftwareFields: false,
        showWeldingApplicationFields: false
    });
    store.onChange("selectedNotificationType", (selectedNotificationType) => {
        store.state.showMachines = !hideMachinesForNotificationTypes.includes(selectedNotificationType);
        store.state.showSoftwareFields = showSoftwareFieldsForNotificationTypes.includes(selectedNotificationType);
        determineShowErrorNumbers();
        determineShowApplications();
    });
    store.onChange("selectedMachineTechnology", () => {
        determineShowErrorNumbers();
        determineShowApplications();
    });
    store.onChange("selectedApplication", (selectedApplication) => {
        store.state.showWeldingApplicationFields = showWeldingApplicationFieldsForApplication.includes(selectedApplication);
    });
    store.onChange("selectedSoftwareType", (selectedSoftwareType) => {
        store.state.showSoftwareModules = showSoftwareModulesForSoftwareTypes.includes(selectedSoftwareType);
    });
    function determineShowApplications() {
        const { selectedNotificationType, selectedMachineTechnology } = store.state;
        store.state.showApplications =
            showApplicationIssuesForNotificationTypes.includes(selectedNotificationType) &&
                showApplicationIssuesForTechnologies.includes(selectedMachineTechnology);
    }
    function determineShowErrorNumbers() {
        const { selectedNotificationType, selectedMachineTechnology } = store.state;
        store.state.showErrorNumbers =
            showErrorNumbersForNotificationTypes.includes(selectedNotificationType) &&
                !hideErrorNumbersForTechnologies.includes(selectedMachineTechnology);
    }
    return store;
};

const ErrorNumberInput = ({ t, prefillData }) => {
    var _a, _b, _c, _d;
    return (h("div", { class: "ux-u-margin-bottom-20" },
        h("label", { class: "ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase" }, t("field.errorNumber.label")),
        h("service-calls-dynamic-input", { "add-text": t("field.errorNumber.addAnotherNumber"), "input-name": "errorNumber1", prefilledValues: ((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.productData) === null || _a === void 0 ? void 0 : _a.errorNumbers) || [], "init-items": ((_c = (_b = prefillData === null || prefillData === void 0 ? void 0 : prefillData.productData) === null || _b === void 0 ? void 0 : _b.errorNumbers) === null || _c === void 0 ? void 0 : _c.length) || 1, "min-items": "1", "max-items": "6", disabled: !!((_d = prefillData === null || prefillData === void 0 ? void 0 : prefillData.productData) === null || _d === void 0 ? void 0 : _d.errorNumbers) },
            h("div", { class: "mf-create-service-case__help-block", slot: "info" },
                h("p", { class: "ux-text-tiny" }, t("field.errorNumber.explanation", {
                    example1: "0000FC00",
                    example2: "1.10.58102409",
                    example3: "6000"
                }))))));
};

const SALUTATION = {
    FEMALE: 1,
    MALE: 2
};

const getLanguageFromLocale = (locale) => {
    if (!locale.includes("-")) {
        return locale;
    }
    return locale.split("-")[0];
};
const getCountryFromLocale = (locale) => {
    if (!locale.includes("-")) {
        return null;
    }
    return locale.split("-")[1];
};

const SalutationInput = ({ t, prefillData }) => {
    var _a, _b, _c;
    return (h("ux-select", { label: t("field.salutation.label"), required: true, name: "salutation" },
        h("option", { value: "", selected: typeof ((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.callBackContact) === null || _a === void 0 ? void 0 : _a.salutation) !== "number", disabled: true }, t("select.placeholder")),
        h("option", { value: SALUTATION.FEMALE, selected: ((_b = prefillData === null || prefillData === void 0 ? void 0 : prefillData.callBackContact) === null || _b === void 0 ? void 0 : _b.salutation) === SALUTATION.FEMALE }, t("field.salutation.female")),
        h("option", { value: SALUTATION.MALE, selected: ((_c = prefillData === null || prefillData === void 0 ? void 0 : prefillData.callBackContact) === null || _c === void 0 ? void 0 : _c.salutation) === SALUTATION.MALE }, t("field.salutation.male"))));
};
const FirstNameInput = ({ t, prefillData }) => {
    var _a;
    return (h("ux-input-field", { "data-validation-required--msg": t("validation.requiredField"), "data-validation-length--max": "45", "data-validation-length--msg": t("validation.maxAllowedCharacters", {
            number: 45
        }), label: t("field.firstName.label"), name: "firstName", value: ((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.callBackContact) === null || _a === void 0 ? void 0 : _a.firstName) || "", required: true }));
};
const LastNameInput = ({ t, prefillData }) => {
    var _a;
    return (h("ux-input-field", { "data-validation-required--msg": t("validation.requiredField"), "data-validation-length--max": "45", "data-validation-length--msg": t("validation.maxAllowedCharacters", {
            number: 45
        }), label: t("field.lastName.label"), name: "lastName", value: ((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.callBackContact) === null || _a === void 0 ? void 0 : _a.lastName) || "", required: true }));
};
const PhoneInput = ({ t, prefillData, locale }) => {
    var _a;
    return (h("ux-phone-input", { label: t("field.phone.label"), language: getLanguageFromLocale(locale), country: getCountryFromLocale(locale), "data-validation-invalid--msg": t("validation.invalidPhoneNumber"), "data-validation-required--msg": t("validation.requiredField"), name: "phone", value: ((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.callBackContact) === null || _a === void 0 ? void 0 : _a.phone) || "", required: true }));
};
const EmailInput = ({ t, prefillData }) => {
    var _a;
    return (h("ux-input-field", { type: "email", required: true, "data-validation-required--msg": t("validation.requiredField"), "data-validation-length--max": "100", "data-validation-length--msg": t("validation.maxAllowedCharacters", {
            number: 100
        }), "data-validation-invalid--msg": t("validation.invalidEmail"), label: "E-Mail", name: "email", value: ((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.callBackContact) === null || _a === void 0 ? void 0 : _a.email) || "" }));
};

const classifications = ["standstill", "fault", "slightImpairment", "generalInquiry"];

const SoftwareModuleSelect = ({ t, prefillData, formStore, apiStore }) => {
    var _a, _b;
    return (h("ux-select", { required: true, label: t("field.softwareModule.label"), "data-validation-required--msg": t("validation.requiredField"), name: "softwareModule", disabled: (_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _a === void 0 ? void 0 : _a.softwareModule },
        h("option", { value: "", selected: !((_b = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _b === void 0 ? void 0 : _b.softwareModule), disabled: true }, t("select.placeholder")),
        getSoftwareModulesByType(apiStore.state.softwares, formStore.state.selectedSoftwareType).map((softwareModule) => {
            var _a;
            return (h("option", { value: softwareModule, selected: softwareModule === ((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _a === void 0 ? void 0 : _a.softwareModule) }, t(`softwareModule.${softwareModule}`)));
        })));
};
const SoftwareTypeSelect = ({ t, prefillData, formStore, apiStore }) => {
    var _a, _b;
    return (h("ux-select", { required: true, label: t("field.softwareType.label"), name: "softwareType", onUxChange: (event) => {
            formStore.state.selectedSoftwareType = event.detail.value;
        }, disabled: (_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _a === void 0 ? void 0 : _a.softwareType },
        h("option", { value: "", selected: !((_b = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _b === void 0 ? void 0 : _b.softwareType), disabled: true }, t("select.placeholder")),
        apiStore.state.softwareTypes.map((softwareType) => {
            var _a;
            return (h("option", { value: softwareType, selected: ((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _a === void 0 ? void 0 : _a.softwareType) === softwareType }, softwareType));
        })));
};
const SoftwareClassificationSelect = ({ t, prefillData }) => {
    var _a;
    const hasPrefilledClassification = classifications.includes((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _a === void 0 ? void 0 : _a.softwareProblemClassification);
    return (h("ux-select", { required: true, label: t("field.softwareProblemClassification.label"), "data-validation-required--msg": t("validation.requiredField"), name: "softwareProblemClassification" },
        h("option", { value: "", selected: !hasPrefilledClassification, disabled: true }, t("select.placeholder")),
        classifications.map((classification) => {
            var _a;
            return (h("option", { value: classification, selected: classification === ((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _a === void 0 ? void 0 : _a.softwareProblemClassification) }, t(`softwareProblemClassification.${classification}`)));
        })));
};
const InstallationCheckbox = ({ t, prefillData }) => {
    var _a, _b;
    return (h("ux-checkbox", { label: t("field.softwareInstallationProblem.label"), name: "installationProblem", checked: (_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _a === void 0 ? void 0 : _a.isInstallationProblem, disabled: typeof ((_b = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _b === void 0 ? void 0 : _b.isInstallationProblem) === "boolean" }));
};
const LicenseCheckbox = ({ t, prefillData }) => {
    var _a, _b;
    return (h("ux-checkbox", { label: t("field.softwareLicenseIssue.label"), name: "licenseIssue", checked: (_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _a === void 0 ? void 0 : _a.isLicenseIssue, disabled: typeof ((_b = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _b === void 0 ? void 0 : _b.isLicenseIssue) === "boolean" }));
};

const ApplicationSelect = ({ t, formStore }) => (h("ux-select", { required: true, label: t("field.application.label"), "data-validation-required--msg": t("validation.requiredField"), name: "application", onUxChange: (event) => {
        formStore.state.selectedApplication = Number(event.detail.value);
    } },
    h("option", { value: "", selected: true, disabled: true }, t("select.placeholder")),
    applicationsLaser.map((application) => (h("option", { value: application.id }, t(`application.${application.labelKey}`))))));
const ApplicationOpticsSelect = ({ t }) => (h("ux-select", { label: t("field.optics.label"), name: "optics" },
    h("option", { value: "", selected: true, disabled: true }, t("select.placeholder")),
    applicationsOptics.map((application) => (h("option", { value: application.id }, t(`application.${application.labelKey}`))))));
const ApplicationIssueSelect = ({ t }) => (h("ux-select", { label: t("field.applicationIssue.label"), name: "applicationIssue" },
    h("option", { value: "", selected: true, disabled: true }, t("select.placeholder")),
    applicationsWelding.map((application) => (h("option", { value: application.id }, t(`application.${application.labelKey}`))))));

const MachineSelect = ({ t, prefillData, apiStore, formStore }) => {
    var _a, _b;
    const { machines } = apiStore.state;
    return (h("ux-select", { required: true, label: t("field.machine.label"), "data-validation-required--msg": t("validation.requiredField"), name: "productNo", onUxChange: (event) => {
            const machine = machines.find(({ assetId }) => assetId === event.detail.value);
            if (machine) {
                formStore.state.selectedMachineTechnology = machine.technologyId;
                return;
            }
            // eslint-disable-next-line no-console
            console.error(`Machine with id ${event.detail.value} not found`);
        }, disabled: (_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.productData) === null || _a === void 0 ? void 0 : _a.assetId },
        h("option", { value: "", selected: !((_b = prefillData === null || prefillData === void 0 ? void 0 : prefillData.productData) === null || _b === void 0 ? void 0 : _b.assetId), disabled: true }, t("select.placeholder")),
        machines.map((machine) => {
            var _a;
            return (h("option", { key: machine.assetId, value: machine.assetId, selected: machine.assetId === ((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.productData) === null || _a === void 0 ? void 0 : _a.assetId) },
                machine.assetName,
                " (",
                machine.assetId,
                ")"));
        })));
};

const NotificationTypeSelect = ({ t, prefillData, apiStore, formStore }) => {
    const { notificationTypes } = apiStore.state;
    const { selectedNotificationType } = formStore.state;
    return (h("ux-select", { required: true, label: t("field.reason.label"), "data-validation-required--msg": t("validation.requiredField"), name: "notificationType", onUxChange: (event) => {
            formStore.state.selectedNotificationType = Number(event.detail.value);
        }, disabled: prefillData === null || prefillData === void 0 ? void 0 : prefillData.notificationType },
        h("option", { value: "", selected: !(prefillData === null || prefillData === void 0 ? void 0 : prefillData.notificationType), disabled: true }, t("select.placeholder")),
        notificationTypes.map((notificationType) => (h("option", { key: String(notificationType.LabelKey), value: notificationType.Id, selected: notificationType.Id === selectedNotificationType }, t(`notificationType.${notificationType.LabelKey}`))))));
};

const assetManagementApiClients = {};
const getAssetManagementApiClient = (config) => {
    const { assetManagementApiBaseUrl, authIssuer, authScope, authClientId } = config;
    const key = `${assetManagementApiBaseUrl}-${authIssuer}-${authScope}-${authClientId}`;
    if (!assetManagementApiClients[key]) {
        assetManagementApiClients[key] = new AssetManagementApiClient(config);
    }
    return assetManagementApiClients[key];
};
class AssetManagementApiClient extends ApiClient {
    /**
     * Request function to send an authenticated POST request to the AssetManagementAPI
     */
    async request(path, options) {
        if (this.config.useMockData) {
            return this.mockRequest(options === null || options === void 0 ? void 0 : options.mockResponse);
        }
        if (this.authClientServiceCalls === null) {
            return Promise.reject("AuthClient not initialized");
        }
        const { method = "POST", headers: additionalHeaders = {}, body: bodyObject } = options || {};
        const headers = Object.assign({ Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${this.token}` }, additionalHeaders);
        const body = bodyObject ? JSON.stringify(bodyObject) : undefined;
        return fetch(`${this.config.assetManagementApiBaseUrl}${path}`, {
            method,
            headers,
            body
        }).then((response) => {
            if (response.status === 401) {
                this.authClientServiceCalls.deleteAccessToken();
                return Promise.reject("Unauthorized");
            }
            if (response.status === 200) {
                return response.json();
            }
            return Promise.reject(`Error ${response.status}`);
        });
    }
}

const createServiceCaseCss = ".mf-create-service-case{display:block}.mf-create-service-case__button-group{display:flex;gap:0 10px;}mf-create-service-case ux-select{width:100%}";
const MfCreateServiceCaseStyle0 = createServiceCaseCss;

const MfCreateServiceCase = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.serviceCaseSubmit = createEvent(this, "mfServiceCaseSubmit", 7);
        this.serviceCaseCancel = createEvent(this, "mfServiceCaseCancel", 7);
        this.apiStore = createApiStore();
        this.authStore = createAuthStore();
        this.formStore = createFormStore();
        this.callId = crypto.randomUUID(); // this browser API only works on localhost and over https
        this.multipleSteps = false;
        this.fileUpload = false;
        this.prefillData = null;
        this.locale = "en-US";
        this.env = "prod";
        this.legacyApi = false;
        this.disableSilentAuth = false;
        this.tbdbError = null;
    }
    connectedCallback() {
        setEnv(`${this.env}${this.legacyApi ? "Legacy" : ""}`);
        this.config = getEnvConfig();
        this.publicApiClient = getPublicApiClient(this.config);
        this.unsubscribeToTbdbToken = this.publicApiClient.subscribeToTbdbToken((event) => {
            if (event.success) {
                loadFormDataFromPublicApi(this.apiStore, this.publicApiClient);
            }
            else {
                this.tbdbError = event.errorMessage || "Error getting TBDB token";
            }
        });
        this.assetManagementApiClient = getAssetManagementApiClient(this.config);
        this.loadTranslations();
        this.i18nSubscriberId = i18nProvider.subscribe(() => forceUpdate(this));
        this.unsubscribeAuth = whenAuthenticated(() => loadFormDataFromAssetManagementApi(this.apiStore, this.assetManagementApiClient));
        this.apiStore.onChange("notificationTypesLoading", (notificationTypesLoading) => {
            var _a;
            if (!notificationTypesLoading) {
                this.formStore.state.selectedNotificationType = ((_a = this.prefillData) === null || _a === void 0 ? void 0 : _a.notificationType) || null;
            }
        });
        document.addEventListener("uxActiveTabSet", (e) => {
            // eslint-disable-next-line no-console
            console.log("uxActiveTabSet", e);
        });
    }
    disconnectedCallback() {
        this.unsubscribeAuth();
        i18nProvider.unsubscribe(this.i18nSubscriberId);
        if (this.unsubscribeToTbdbToken) {
            this.unsubscribeToTbdbToken();
        }
    }
    onLocaleChange() {
        if (this.locale !== i18nProvider.language) {
            this.loadTranslations();
        }
    }
    onPrefillDataChange() {
        var _a;
        const notificationType = (_a = this.prefillData) === null || _a === void 0 ? void 0 : _a.notificationType;
        if (notificationType) {
            this.formStore.state.selectedNotificationType = notificationType;
        }
    }
    loadTranslations() {
        loadTranslations(this.locale).then((locale) => {
            i18nProvider.changeLanguage(locale);
            this.locale = locale;
        });
    }
    onSubmit(event) {
        event.preventDefault();
        const { softwares } = this.apiStore.state;
        const { form, callId } = this;
        const data = createRequestData({
            form,
            callId,
            softwares,
            selectedMachineTechnology: this.formStore.state.selectedMachineTechnology
        });
        const files = this.fileUpload
            ? Array.from(form.querySelectorAll("input[type='file']")).reduce((acc, input) => {
                return acc.concat(Array.from(input.files || []));
            }, [])
            : [];
        this.serviceCaseSubmit.emit({ data, callId, files });
        this.formStore.state.formIsSubmitted = true;
        if (this.config.logging) {
            // eslint-disable-next-line no-console
            console.log("Form submitted", data);
        }
    }
    onCancel() {
        this.serviceCaseCancel.emit();
    }
    render() {
        const t = (key, options = undefined) => i18nProvider.t(`mf-service-calls:${String(key)}`, options);
        const { loading } = this.apiStore.state;
        const { isAuthenticating, authError } = this.authStore.state;
        const { prefillData, multipleSteps } = this;
        const { showErrorNumbers, formIsSubmitted, showApplications, showSoftwareModules, showMachines, showSoftwareFields, showWeldingApplicationFields } = this.formStore.state;
        const showContent = !(loading || isAuthenticating || authError);
        return (h(Host, { key: 'd9b4261b49dfd6036683a5e4e13e110a560350d0' }, !formIsSubmitted && (h("ux-form", { key: 'f0f28f377a085adb7de6c74c29f5e016913abc15', "data-validation-required--msg": t("validation.requiredField") }, h(FormSteps, { key: 'bb812a3691031433115aec4c475e2bdf487e66c2', multipleSteps: multipleSteps }, h("form", { key: '20eb6d0fa189c9f8bf5f2cedbf9f13d7e1c67498', onSubmit: (e) => this.onSubmit(e), ref: (el) => (this.form = el) }, h("div", { key: 'b6958d049d48ffdacfb1126ebdb65c4c2c931ca5', class: "ux-u-text-align--center ux-u-margin-top-60 ux-u-margin-bottom-60" }, h("div", { key: '88fa0c58e92bd0c69aa80375ded997acc172fec8', class: "ux-text-headline ux-text-headline--giant" }, t("headline.createCase"))), (loading || isAuthenticating) && (h("ux-loader", { key: '03bdba056cc2ab42ba7272826d6777ee7d2182fe', class: "ux-u-margin-bottom-40", variant: "spinner" })), authError && (h("div", { key: 'ef1538a51bfa5a1ccf80869231edf57ea96045c8', class: "ux-u-text-align--center ux-text-normal ux-u-margin-top-20 ux-u-margin-bottom-20" }, t("auth.error"))), h("div", { key: '74ed32a151893872622801191350a44491e182f4', style: { display: showContent ? "block" : "none" } }, h(FormStep, { key: 'a8855c1f7ef737eb77f8b9f1f2865ad0cd01021c', multipleSteps: multipleSteps }, h(StepNavigation, { key: 'f3713b6d93806b8d60feca069a9f5b40e52970d1', t: t, multipleSteps: multipleSteps, currentStep: 1 }), h("div", { key: '817d176af692dae7e31ba34abee8e715a267ad10', class: "ux-row ux-u-flex-jc-center" }, h("div", { key: 'a65e18292e60692e20b86f766fae4134420ead32', class: "ux-col-12 ux-col-md-10" }, h("div", { key: '7e7ab0ad7323a6c771854e68fb5a92e882fc6b01', class: "ux-row" }, h("div", { key: '93537688c31d4b8da3507defea0a08e7da0489a4', class: "ux-col-12 ux-col-md-6" }, h("div", { key: 'ed2822a8a7041135c51c658b0f724a1cc7d00407', class: "ux-u-margin-bottom-20" }, h(NotificationTypeSelect, { key: '2465bc5e0656b4a70a4835cecb074083751094f3', t: t, prefillData: prefillData, formStore: this.formStore, apiStore: this.apiStore }))), showMachines && (h("div", { key: '94f6976625c69a51206e29a88471a189ebd8f135', class: "ux-col-12 ux-col-md-6" }, h("div", { key: 'd49bfb741c14f1a7b508b4b8866866d5f5b5a044', class: "ux-u-margin-bottom-20" }, h(MachineSelect, { key: '1700270c87582084dd2cd550f014af4c7fd5df6c', t: t, prefillData: prefillData, formStore: this.formStore, apiStore: this.apiStore }))))), showApplications && (h(Fragment, { key: '04294cbd19101a736a50c3a0bc0df20c54ab6b53' }, h("div", { key: '608ebc8b751ff345a9908f686c40c0aa491d5cf3', class: "ux-row" }, h("div", { key: '3b05478410cf510a0e0b2e0db61ee4dca6e12088', class: "ux-col-12 ux-col-md-6" }, h("div", { key: '917d51df6e72985044918b0ef5277c7f62d99c91', class: "ux-u-margin-bottom-20" }, h(ApplicationSelect, { key: '72e0df0dea8a9df19d750d42c92ad09246070fa7', t: t, formStore: this.formStore })))), showWeldingApplicationFields && (h("div", { key: 'dfb5431c46456ab1b8a75dadd75726577700652b', class: "ux-row" }, h("div", { key: '96f8799b178a180a96c050182b0084fdbaefe979', class: "ux-col-12 ux-col-md-6" }, h("div", { key: '928e41ca3b3827a9f80ced63335d2d70897b5f27', class: "ux-u-margin-bottom-20" }, h(ApplicationOpticsSelect, { key: 'ef743d9795c75c83de2b48091ca5a2bc75c7a584', t: t }))), h("div", { key: 'b4cd886f6dec2eede5b9b57b19e82cd62a6c3a8d', class: "ux-col-12 ux-col-md-6" }, h("div", { key: 'd8cee8f8094ae715828cb38d3eb809c37184e086', class: "ux-u-margin-bottom-20" }, h(ApplicationIssueSelect, { key: '81b83102da6ab11a693c29ddf78d5ba4f2a825a0', t: t }))))))), showSoftwareFields && (h(Fragment, { key: '643cac971067c0244cb9692a2b7887d866226610' }, h("div", { key: '1b39a2c3de9845549965d88b911dc338c81b1300', class: "ux-row" }, h("div", { key: '34e9551d819733ae74e4a3b67051cc2876bf645f', class: "ux-col-12 ux-col-md-6" }, h("div", { key: '9b45a5a5e5dfa5f32acf04c050cacb63af8c7987', class: "ux-u-margin-bottom-20" }, h(SoftwareClassificationSelect, { key: '454c6cc6514af4d143042b8443dda2fe6c68d35d', t: t, prefillData: prefillData })))), h("div", { key: 'f9a183650251bc35e6f576084190bbf8c75fd64d', class: "ux-row" }, h("div", { key: '25abc6005fb65d9b1a6dd049ad9d3d7f43209b58', class: "ux-col-12 ux-col-md-6" }, h("div", { key: '7e4d714b567ca20fefb75a472b36ac7bd80106ce', class: "ux-u-margin-bottom-20" }, h(InstallationCheckbox, { key: '554e9c331793622f106bed8fdaea52e18b35b500', t: t, prefillData: prefillData }))), h("div", { key: '8972b0b8bbb5ab70a272be3fdd6802f2f185cecb', class: "ux-col-12 ux-col-md-6" }, h("div", { key: '5294d7d927e0078661e84924581e2f45dd18c154', class: "ux-u-margin-bottom-20" }, h(LicenseCheckbox, { key: '3ef22ce8de39b114eae4ded5cfebbb9163cbe30d', t: t, prefillData: prefillData })))), h("div", { key: 'a970b66fb729d9c1587588bfb2f4a037868e590a', class: "ux-row" }, h("div", { key: 'f7112778608eaef9354f657a90eaba77bb8a5398', class: "ux-col-12 ux-col-md-6" }, h("div", { key: '9ecdd2cb683353d466be3144f6b987877d99cdd3', class: "ux-u-margin-bottom-20" }, h(SoftwareTypeSelect, { key: '27c78574be8af609902aeb368a4ea538182a1473', t: t, prefillData: prefillData, formStore: this.formStore, apiStore: this.apiStore }))), showSoftwareModules && (h("div", { key: '699863171715b5247dd5f083cca8d9470b700d06', class: "ux-col-12 ux-col-md-6" }, h("div", { key: '063b3c1a6017fed11d60afd3ab38efb26e5c3e1e', class: "ux-u-margin-bottom-20" })))), h("div", { key: 'ea3beefe4ad7abec615c862f12601cfee9c7379f', class: "ux-row" }, showSoftwareModules && (h("div", { key: '33bbec60735f9fb0a76d5a8009c42d3127897d9d', class: "ux-col-12 ux-col-md-6" }, h("div", { key: '445796d6859ebb1a5e8c9abfc83df07223bce638', class: "ux-u-margin-bottom-20" }, h(SoftwareModuleSelect, { key: '07149348f02f06c34f87483f671173e249749c99', t: t, prefillData: prefillData, formStore: this.formStore, apiStore: this.apiStore }))))))), showErrorNumbers && (h("div", { key: '6cafbe6c9d8acd3257b8f25fc27c64615ce63a55', class: "ux-row" }, h("div", { key: 'a41294c3a26e45a36013c3f6ecf2d8fcfdcfc5b1', class: "ux-col-12" }, h(ErrorNumberInput, { key: 'e8aa092c9c8b6b74c0797be5565da6f4e85338ee', t: t, prefillData: prefillData })))), h("div", { key: '0aad86a954a1ce0844977e095b804872330dcd56', class: "ux-row" }, h("div", { key: '3651eebb3b4a9789f99e2e6b7d073110dfcb0a29', class: "ux-col-12" }, h("div", { key: '3335a16caafb6ccdb678e3d076082f7d04002950', class: "ux-u-margin-bottom-20" }, h("ux-textarea-field", { key: '640f9794a253074200fac36bed324561f42d8dbf', label: t("field.message.label"), placeholder: t("field.message.placeholder"), required: true, "data-validation-required--msg": t("validation.requiredField"), name: "description" })))), this.fileUpload && (h("div", { key: '420401bb043771c7d9db4f3a9d85501539d52136', class: "ux-row" }, h("div", { key: '19abddd41505148e11599e6f44aabbbf6acdceb6', class: "ux-col-12" }, h("div", { key: '22003b4f75d56b38a0486ee196104a0c29689383', class: "ux-u-margin-bottom-20" }, h("ux-file-upload", { key: 'e0648c617a27589704b23b5f1a2edb5c2861b0a1', "max-file-size": "2", label: t("field.fileUpload.label"), "accepted-files": "image/*,application/pdf,text/html", "max-files": "4" }))))), h(StepNext, { key: '864d1d7a578e7eeebc0d9a694408ba3a13be5951', t: t, multipleSteps: multipleSteps, onCancel: () => this.onCancel() })))), h(FormStep, { key: 'dad9297fb07f174ba8ed16fc9e21da81681470c3', multipleSteps: multipleSteps }, h(StepNavigation, { key: 'aaed40f496a5023d8edb6662f9aca462748014d5', t: t, multipleSteps: multipleSteps, currentStep: 2 }), h("div", { key: 'd10c45bd1e8c057787d604bb3f93414a28479eeb', class: "ux-row ux-u-flex-jc-center" }, h("div", { key: '27fd0631a6b8683b3d5e471540086b9c09d4bdbc', class: "fields-wrapper ux-col-12 ux-col-md-10" }, h("div", { key: '5d89f41d5eaa8c7a73de84fa94c9096e6680b188' }, h("slot", { key: '373414724c2c572c33d388a953bbe6f341789843', name: "contacts-button" })), h("div", { key: '63eef346d5642aa75830a3507cf3e51a9a54ac66', class: "ux-row" }, h("div", { key: 'f8ce117b2d09bd950af6fd63ff2bce446473641d', class: "ux-col-12 ux-col-md-6" }, h("div", { key: 'aeab53a497de4ab6066ab6dadd83feb31f65233d', class: "ux-u-margin-bottom-20" }, h(SalutationInput, { key: '174c3f9aec601b50f5c3953fe8957598df84827a', t: t, prefillData: prefillData })))), h("div", { key: 'de6509d7be4af7e1a2927289c0156588a4525019', class: "ux-row" }, h("div", { key: 'b98e8647024108105f03674e6211a14537fa0365', class: "ux-col-12 ux-col-md-6" }, h("div", { key: 'd735d3b55ffabda5640c518e55b8459eb08613e1', class: "ux-u-margin-bottom-20" }, h(FirstNameInput, { key: '5410310d4f65f451388225a28ae054c7cd2eb20d', t: t, prefillData: prefillData }))), h("div", { key: '7141f08a32ca7c159c5bc2cfb1a5c9cb8b13bd61', class: "ux-col-12 ux-col-md-6" }, h("div", { key: '537bc1288b9778651ae3a46e6734f1e3f9868698', class: "ux-u-margin-bottom-20" }, h(LastNameInput, { key: 'bd552f5bd06328744c374883a9b243a37174e56e', t: t, prefillData: prefillData })))), h("div", { key: 'cdf6ccba8a45f1bd646a4404a4bdb03f976b0bd0', class: "ux-row" }, h("div", { key: 'a4b2aae05c28d23859fdfde446c4d71d9b0544f6', class: "ux-col-12 ux-col-md-6" }, h("div", { key: '787961bd5d8e58a2c8837e7ec2b968e2b9074710', class: "ux-u-margin-bottom-20" }, h(PhoneInput, { key: '50b5d223829cbe44ad30bad47fbe43ec089fd27a', t: t, prefillData: prefillData, locale: this.locale }))), h("div", { key: 'f9205d1fca061dc0d3d6b89c6c9a1489c0045d91', class: "ux-col-12 ux-col-md-6" }, h("div", { key: 'f9eaaaa345cc9a841ea64c6b80d294853bb4180c', class: "ux-u-margin-bottom-20" }, h(EmailInput, { key: '85d63411dfb20c600071805a97b1538a7e070591', t: t, prefillData: prefillData })))), h("div", { key: '3405a26b113b19c641e53e7b98089883e2552ace', class: "ux-u-margin-bottom-20" }, h("div", { key: '5702a58872fab22cc88df79b3590088b052a99f1', class: "ux-text-normal ux-text-normal--light-gray" }, h("p", { key: 'e9af8389cf1f50d6bb1d59491b33e6e08d495439' }, t("validation.requiredFieldsExplanation")))), h("div", { key: '4e25a09a3493fb86130083177db088ca8ae762d0', class: "ux-u-d-flex ux-u-flex-jc-between ux-u-flex-dir-row-reverse" }, h("ux-button", { key: 'd3445161d263c1f14cf6c7aa245a19b0e3cf38a4', type: "submit", variant: "primary" }, t("button.submit")), h(StepBack, { key: '82c4e678d5c00bb2f0e1a38b8278f74c37f7e73a', t: t, multipleSteps: multipleSteps }), !multipleSteps && (h("ux-button", { key: '30a71cf77d77e8bbee482c8aa14d7956f887ac99', type: "button", onClick: () => this.onCancel(), formnovalidate: true }, t("button.cancel")))))))))))), h("div", { key: 'a78f7c8bff3c8a78afffa9ec73dd9be49af3ea4d', style: { display: formIsSubmitted ? "block" : "none" } }, h("slot", { key: '98ea184ab8458fc7c80b914b241bdd957231ae30', name: "connector" })), h(SilentAuth, { key: 'aafb20121d937a8890e01d69fc726122fc2e56c4', config: this.config, disabled: this.disableSilentAuth, authStore: this.authStore })));
    }
    static get watchers() { return {
        "locale": ["onLocaleChange"],
        "prefillData": ["onPrefillDataChange"]
    }; }
};
MfCreateServiceCase.style = MfCreateServiceCaseStyle0;

export { MfCreateServiceCase as mf_create_service_case };

//# sourceMappingURL=mf-create-service-case.entry.js.map